import {NO_ERRORS_SCHEMA, NgModule} from '@angular/core';
import {DSTClickOutsideDirective} from './dstClickOutside.directive';
import {DragAndDropUploadDirective} from './drag-and-drop-upload.directive';
import { GtBusSearchDirective } from './GtBusSearchDirective';
import { GtBusinessAssignTreeDirective } from './GtBusinessAssignTreeDirective';
import { GtBusinessAssignMenuComponent } from './GtBusinessAssignMenuDirective';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AppNgAppkitModule } from '../../app-ng-appkit.module';
import { OnlyDigitsDecimalDirective } from './only-digits-decimal.directive';
import { OnlyIntegersWithLengthDirective } from './only-integers-with-length.directive';
import { OnlyDigitsDecimalWithLengthDirective } from './only-digits-decimal-with-length.directive';
import { DfSelectSingleDirective } from './df-select-single/df-select-single.directive';
import { DfSelectMultipleDirective } from './df-select-multiple.directive';
import { CustomSelectLocalSystemDirective } from './custom-select-local-system.directive';

@NgModule({
  declarations: [
    DSTClickOutsideDirective,
    DragAndDropUploadDirective,
    GtBusSearchDirective,
    GtBusinessAssignTreeDirective,
    GtBusinessAssignMenuComponent,
    OnlyDigitsDecimalDirective,
    OnlyIntegersWithLengthDirective,
    OnlyDigitsDecimalWithLengthDirective,
    DfSelectSingleDirective,
    DfSelectMultipleDirective,
    CustomSelectLocalSystemDirective
  ],
  imports: [CommonModule, FormsModule, AppNgAppkitModule],
  exports: [
    DSTClickOutsideDirective,
    DragAndDropUploadDirective,
    GtBusSearchDirective,
    GtBusinessAssignTreeDirective,
    GtBusinessAssignMenuComponent,
    OnlyDigitsDecimalDirective,
    OnlyIntegersWithLengthDirective,
    OnlyDigitsDecimalWithLengthDirective,
    DfSelectSingleDirective,
    DfSelectMultipleDirective,
    CustomSelectLocalSystemDirective
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class SharedDirectivesModule {
}
